<template>
  <v-container>
    <div class="breadcrumbs-wrap">
      <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
    </div>
    <h1 class="title-pg">{{ $t('Отчеты по БСО') }}</h1>
    <div class="my-organization">
      <div class="blanks-pg bso-reports bgw-pdg-20">
        <div class="search-head">
          <v-row>
            <v-col>
              <v-label>{{ $t('Номер разрешения') }}</v-label>
              <v-text-field
                v-model="search.bsoNumber"
                outlined
                dense
                clearable
              />
            </v-col>
            <v-col>
              <v-label>{{ $t('Номер отст. карты/троф. листа') }}</v-label>
              <v-text-field
                v-model="search.childrenBsoNumber"
                outlined
                dense
                clearable
              />
            </v-col>
            <v-col>
              <v-label>{{ $t('Серии разрешения') }}</v-label>
              <div class="select-def">
                <v-select
                  :items="permitTypes"
                  item-value="id"
                  item-text="transCorrectName"
                  v-model="search.permitType"
                  :placeholder="$t('Все')"
                  outlined
                  dense
                  clearable
                />
              </div>
            </v-col>
            <v-col>
              <v-label>{{ $t('Серии отст. карты/троф. листа') }}</v-label>
              <div class="select-def">
                <v-select
                  :items="childrenTypes"
                  item-value="id"
                  item-text="transCorrectName"
                  v-model="search.childrenType"
                  :placeholder="$t('Все')"
                  outlined
                  dense
                  clearable
                />
              </div>
            </v-col>
          </v-row>
          <div class="search-action">
            <button
              class="btn btn-default green-grassy"
              @click="itemList()"
            >
              {{ $t('Поиск') }}
            </button>
            <button
              class="btn btn-default gray"
              @click="resetSearch(), itemList()"
            >
              {{ $t('Очистить') }}
            </button>
          </div>
        </div>
<!--        <ReportWordPrintModal :ooptId="$route.params.id" :oopts="oopts" :refYears="refYears"/>-->
        <div class="search-body">
          <div class="table-overflow">
            <table class="table-full">
              <thead>
              <tr>
                <td class="td-lg">
                  <div class="sort-flex">
                    {{ $t('Серия и № разрешения, срок действия, вид животного') }}
                    <a @click="sort('bsoNumber')" class="sort-btn sort-blue">
                      <v-icon v-if="sortParams.field == 'bsoNumber' && sortParams.order == 'DESC'">arrow_drop_up</v-icon>
                      <v-icon v-else>arrow_drop_down</v-icon>
                    </a>
                  </div>
                </td>
                <td class="td-sm">
                  <div class="sort-flex">
                    {{ $t('Статус отчета') }}
                    <a @click="sort('permitReportStatus')" class="sort-btn sort-blue">
                      <v-icon v-if="sortParams.field == 'permitReportStatus' && sortParams.order == 'DESC'">arrow_drop_up</v-icon>
                      <v-icon v-else>arrow_drop_down</v-icon>
                    </a>
                  </div>
                </td>
                <td>
                  <div class="sort-flex">
                    {{ $t('Серия и № отст. карты/троф. листа, вид животного') }}
                    <a @click="sort('childrenBsoNumber')" class="sort-btn sort-blue">
                      <v-icon v-if="sortParams.field == 'childrenBsoNumber' && sortParams.order == 'DESC'">arrow_drop_up</v-icon>
                      <v-icon v-else>arrow_drop_down</v-icon>
                    </a>
                  </div>
                </td>
                <td>
                  <div class="sort-flex">
                    {{ $t('Охотник') }}
                  </div>
                </td>
                <td>
                  <div class="sort-flex">
                    {{ $t('Результат охоты') }}
                  </div>
                </td>
              </tr>
              </thead>
              <tbody>
              <template v-for="(item, i) in items">
                <tr :key="i" :style="'background-color:' + item.color">
                  <td class="td-lg" :rowspan="item.childrenLength + 1">
                    <p>
                      <router-link tag="a"
                                   :to="{ name: 'permit-report-' + item.urlPrefix, params: { id: item.id } }"
                      >
                        {{ item.strictReportingFormTypeCorrectName }} {{ item.bsoNumber}}
                      </router-link>
                    </p>
                    <p v-if="item.validDateFrom || item.validDateTo">
                      {{ item.validDateFrom }} - {{ item.validDateTo }}
                    </p>
                  </td>
                  <td :rowspan="item.childrenLength + 1">
                    <p v-if="item.permitReportsStatusName">{{ item.permitReportsStatusName }}</p>
                  </td>
                </tr>
                <template v-if="item.children && item.children.shooting_card">
                  <tr :style="'background-color:' + item.color" v-for="(shooting_card, iCard) in item.children.shooting_card" :key="iCard">
                    <td>
                      <router-link tag="a"
                                   :to="{ name: 'permit-report-' + item.urlPrefix, params: { id: item.id }, query: { tab: 1, tabShootingCard: iCard } }"
                      >
                        {{ shooting_card.strictReportingFormTypeCorrectName }} {{ shooting_card.bsoNumber}}
                      </router-link>
                      <p>{{ shooting_card.faunaName }}</p>
                      <p v-if="shooting_card.validDateFrom || shooting_card.validDateTo">
                        {{ shooting_card.validDateFrom }} - {{ shooting_card.validDateTo }}
                      </p>
                    </td>
                    <td>
                      <p v-if="shooting_card.ooptHunterFio">{{ shooting_card.ooptHunterFio }}</p>
                      <p v-if="shooting_card.ooptHunterCountryName">{{ shooting_card.ooptHunterCountryName }}</p>
                    </td>
                    <td>
                      <p v-if="shooting_card.huntingResultName">{{ shooting_card.huntingResultName }}</p>
                    </td>
                  </tr>
                </template>
                <template v-if="item.children && item.children.trophySheet">
                  <tr :style="'background-color:' + item.color" v-for="(trophySheet, iSheet) in item.children.trophySheet" :key="iSheet">
                    <td>
                      <router-link tag="a"
                                   :to="{ name: 'permit-report-' + item.urlPrefix, params: { id: item.id }, query: { tab: 2, tabTrophySheet: iSheet } }"
                      >
                        {{ trophySheet.strictReportingFormTypeCorrectName }} {{ trophySheet.bsoNumber}}
                      </router-link>
                      <p>{{ trophySheet.faunaName }}</p>
                      <p v-if="trophySheet.validDateFrom || trophySheet.validDateTo">
                        {{ trophySheet.validDateFrom }} - {{ trophySheet.validDateTo }}
                      </p>
                    </td>
                    <td>
                      <p v-if="trophySheet.ooptHunterFio">{{ trophySheet.ooptHunterFio }}</p>
                      <p v-if="trophySheet.ooptHunterCountryName">{{ trophySheet.ooptHunterCountryName }}</p>
                    </td>
                    <td></td>
                  </tr>
                </template>
              </template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import { mapMutations } from 'vuex'
import PermitReport from '@/model/permitReport'
import ReportWordPrintModal from '@/components/bso/ReportWordPrintModal'

export default {
  components: {
    ReportWordPrintModal
  },
  data: () => ({
    breadcrumbs: [],
    permitTypes: [],
    childrenTypes: [],
    refYears: [],
    oopts: [],
    soates: [],
    search: {},
    items: [],
    ooptName: null,
    page: 1,
    paginationData: {},
    sortParams: {
      field: 'bsoNumber',
      order: 'DESC'
    }
  }),
  mounted () {
    this.fetchData()
    this.scrollToTop()
  },
  methods: {
    ...mapMutations(['setLoading']),
    fetchData () {
      this.setLoading(true)
      PermitReport.getSearchFormData()
        .then((response) => {
          this.permitTypes = response.data.permitTypes
          this.childrenTypes = response.data.childrenTypes
          this.refYears = response.data.refYears
          this.oopts = response.data.oopts
          this.soates = response.data.soates
          this.itemList()
          this.generateBreadcrumbs()
        })
        .catch((error) => {
          this.$router.push({
            name: 'error',
            params: {
              status: error.response.status
            }
          })
        })
      this.setLoading(false)
    },
    itemList (resetPage = true) {
      this.setLoading(true)
      if (resetPage) {
        this.page = 1
      }
      this.search.page = this.page
      this.search.sortField = this.sortParams.field
      this.search.sortOrder = this.sortParams.order
      PermitReport.getOoptFaunaApplicationBsos(this.$route.params.id, this.search).then((response) => {
        this.items = response.data.items
        this.paginationData = response.data.paginationData
      }).catch((error) => {
        this.$router.push({
          name: 'error',
          params: {
            status: error.response.status
          }
        })
      })
      this.setLoading(false)
    },
    sort (field) {
      this.sortParams.field = field
      this.sortParams.order = this.sortParams.order === 'ASC' ? 'DESC' : 'ASC'

      this.itemList()
    },
    resetSearch () {
      this.page = 1
      this.search = {}
      this.sortParams = {
        field: 'bsoNumber',
        order: 'DESC'
      }
    },
    generateBreadcrumbs () {
      this.breadcrumbs = [
        {
          text: this.$i18n.t('Главная'),
          disabled: false,
          href: '/'
        },
        {
          text: this.$i18n.t('Рабочий кабинет'),
          disabled: false,
          href: '/my-organization'
        },
        { text: this.oopts[0].transName, disabled: false, href: '/my-organization?id=' + this.$route.params.id },
        {
          text: this.$i18n.t('Отчеты по БСО'),
          disabled: true
        }
      ]
    },
    // Прокручивание к началу страницы
    scrollToTop () {
      window.scrollTo(0, 0)
    }
  }
}
</script>

<style scoped>

</style>
